import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, SelectMenu, SimpleModal } from '@livable/saas-react-components';
import { Alert, Button, Checkbox, FormControlLabel, FormGroup, MenuItem, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const AmenityModal = observer(_ref => {
  let _ref$selectedAmenity = _ref.selectedAmenity,
    selectedAmenity = _ref$selectedAmenity === void 0 ? '' : _ref$selectedAmenity,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? '' : _ref$info,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(selectedAmenity),
    _useState2 = _slicedToArray(_useState, 2),
    amenity = _useState2[0],
    setAmenity = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAmenityOptions = _useState4[0],
    setSelectedAmenityOptions = _useState4[1];
  const _useState5 = useState(selectedAmenity ? selectedAmenity.amenitySelectedOption : selectedAmenityOptions[0]),
    _useState6 = _slicedToArray(_useState5, 2),
    amenityOption = _useState6[0],
    setAmenityOption = _useState6[1];
  const handleGenericModalClose = (event, callback) => {
    if (selectedAmenity && !selectedAmenity.isSaving) {
      store.addNewProperty.utilitiesSetupV2.setSelectedAmenityOption(selectedAmenity, amenityOption);
    }
    store.addNewProperty.utilitiesSetupV2.setAmenitySavingMode(selectedAmenity, undefined, false);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    callback && callback();
  };
  const handleAmenityChange = event => {
    if (event.target.value) setAmenity(event.target.value);
    setSelectedAmenityOptions(store.addNewProperty.utilitiesSetupV2.availableCommonAreaAmenities.find(i => i.id === event.target.value).commonAreaAmenityOptions);
    if (selectedAmenity) {
      var _selectedAmenity$comm;
      store.addNewProperty.utilitiesSetupV2.replaceSelectedAmenity(event.target.value, selectedAmenity.id);
      setAmenity(selectedAmenity);
      setAmenityOption(selectedAmenity.amenitySelectedOption || ((_selectedAmenity$comm = selectedAmenity.commonAreaAmenityOptions[0]) === null || _selectedAmenity$comm === void 0 ? void 0 : _selectedAmenity$comm.id));
    } else {
      var _store$addNewProperty;
      const amenityInitOption = (_store$addNewProperty = store.addNewProperty.utilitiesSetupV2.availableCommonAreaAmenities.find(i => i.id === event.target.value)) === null || _store$addNewProperty === void 0 || (_store$addNewProperty = _store$addNewProperty.commonAreaAmenityOptions[0]) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.id;
      if (amenityInitOption) setAmenityOption(amenityInitOption);
    }
  };
  const handleAmenityOptionChange = function (e, value) {
    let blockEventPropagation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    blockEventPropagation && e.stopPropagation();
    if (selectedAmenity && value && amenityOption) {
      store.addNewProperty.utilitiesSetupV2.setSelectedAmenityOption(selectedAmenity, value);
    }
    if (!selectedAmenity && value) {
      setAmenityOption(value);
    }
  };
  const amenityHandler = (event, commonAreaAmenityId, currentAmenity) => {
    const handlingAmenity = store.addNewProperty.utilitiesSetupV2.availableCommonAreaAmenities.find(i => i.id === commonAreaAmenityId || i.id === (currentAmenity === null || currentAmenity === void 0 ? void 0 : currentAmenity.id));

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    store.addNewProperty.utilitiesSetupV2.setSelectedAmenities(handlingAmenity);
    if (amenityOption !== undefined) {
      store.addNewProperty.utilitiesSetupV2.setSelectedAmenityOption(handlingAmenity, amenityOption);
    }
  };
  const addAmenity = (event, commonAreaAmenityId) => {
    store.addNewProperty.utilitiesSetupV2.setAmenitySavingMode(undefined, commonAreaAmenityId, true);
    amenityHandler(event, commonAreaAmenityId, null);
  };
  const editAmenity = (event, customAmenity) => {
    store.addNewProperty.utilitiesSetupV2.setAmenitySavingMode(customAmenity, undefined, true);
    // amenityHandler(event, null, customAmenity);
  };
  const pods = ['Primary: 81062A Hawaii Street', 'POD #1: 81062C Hawaii Street', 'POD #2: 81062C Hawaii Street', 'POD #3: 81062C Hawaii Street', 'POD #4: 81062C Hawaii Street', 'POD #5: 81062C Hawaii Street', 'POD #6: 81062C Hawaii Street'];
  const editAmenityTrigger = /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.billingItem, " billingItemTable"),
    onClick: () => {
      setAmenityOption(selectedAmenity.amenitySelectedOption);
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, info)), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    'custom-attribute': '158-amenity-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: e => {
      e.stopPropagation();
      if (selectedAmenity.isFetched && selectedAmenity.id !== selectedAmenity.commonAreaAmenityId) {
        store.addNewProperty.utilitiesSetupV2.addCADToDelete(selectedAmenity);
      }
      store.addNewProperty.utilitiesSetupV2.removeSelectedAmenity(selectedAmenity);
    },
    'custom-attribute': '159-amenity-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }))));
  const addNewAmenityTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '160-amenity-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.add_common_area_amenity')));
  const headerTitle = selectedAmenity ? "".concat(t('general.edit'), " ").concat(selectedAmenity.name) : t('add_new_property_flow.add_common_area_amenity');
  const GetForm = _ref2 => {
    var _selectedAmenityOptio;
    let handleModalClose = _ref2.handleModalClose,
      handler = _ref2.handler;
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
      className: classes.content
    }, !selectedAmenity && /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.select_which_amenity_to_add')), /*#__PURE__*/React.createElement("div", {
      className: classes.mdSection
    }, /*#__PURE__*/React.createElement(SelectMenu, {
      id: "amenity-selector",
      value: selectedAmenity.commonAreaAmenityId || amenity,
      label: "Amenity",
      labelId: "amenity-selector-label",
      onChange: handleAmenityChange
    }, store.addNewProperty.utilitiesSetupV2.availableCommonAreaAmenities.filter(am => !store.addNewProperty.utilitiesSetupV2.selectedAmenities.map(i => i.commonAreaAmenityId).includes(am.commonAreaAmenityId)).map(amenityUnit => {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: amenityUnit.id,
        key: amenityUnit.id
      }, amenityUnit.name);
    })), !selectedAmenity && selectedAmenityOptions.length ? /*#__PURE__*/React.createElement("div", {
      className: classes.lgSection
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(!selectedAmenity ? classes.section : '')
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('general.sub_options'))), /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
      value: amenityOption || ((_selectedAmenityOptio = selectedAmenityOptions[0]) === null || _selectedAmenityOptio === void 0 ? void 0 : _selectedAmenityOptio.id),
      onChange: handleAmenityOptionChange,
      exclusive: true
    }, selectedAmenityOptions.map(option => {
      return /*#__PURE__*/React.createElement(ToggleButton, {
        value: option.id,
        key: option.id
      }, option.name);
    })))) : ''), selectedAmenity && selectedAmenity.commonAreaAmenityOptions && selectedAmenity.commonAreaAmenityOptions.length ? /*#__PURE__*/React.createElement("div", {
      className: classes.lgSection
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(!selectedAmenity ? classes.section : '')
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, "".concat(selectedAmenity.name, " ").concat(t('general.sub_options')))), /*#__PURE__*/React.createElement("div", {
      className: classes.smSection
    }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
      value: selectedAmenity.amenitySelectedOption,
      onChange: (event, value) => handleAmenityOptionChange(event, value, true),
      exclusive: true
    }, selectedAmenity.commonAreaAmenityOptions.map(option => {
      return /*#__PURE__*/React.createElement(ToggleButton, {
        value: option.id,
        key: option.id,
        'custom-attribute': '161-amenity-modal-' + option.name
      }, option.name);
    })))) : '', multiple && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classes.xlSection
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.amenity_is_shared_between'), ":")), /*#__PURE__*/React.createElement("div", {
      className: classes.pods
    }, pods.map((pod, index) => /*#__PURE__*/React.createElement(FormGroup, {
      key: "".concat(pod, "_").concat(index)
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: true
      }),
      label: pod
    })))))), /*#__PURE__*/React.createElement("div", {
      className: classes.modalFooter
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.footerEven
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.footerWrapper
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      onClick: () => {
        //eslint-disable-next-line @typescript-eslint/no-unused-expressions
        !!amenityOption && !!(selectedAmenity !== null && selectedAmenity !== void 0 && selectedAmenity.commonAreaAmenityOptions) && store.addNewProperty.utilitiesSetupV2.setSelectedAmenityOption(selectedAmenity, amenityOption);
        handleModalClose();
      },
      'custom-attribute': '162-amenity-modal'
    }, "Cancel")), /*#__PURE__*/React.createElement("div", {
      className: classes.footerWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.footerButton
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "priority",
      disabled: store.utilityProviders.addCustomUtilityProvidersAsync.inProgress || false,
      onClick: event => {
        handler(event, amenity);
        handleModalClose();
      },
      'custom-attribute': '163-amenity-modal'
    }, selectedAmenity ? t('buttons.confirm') : t('add_new_property_flow.add_amenity')))))));
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: selectedAmenity ? editAmenityTrigger : addNewAmenityTrigger,
    title: headerTitle,
    handleClose: handleGenericModalClose,
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.cad')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.cad_hint'))), /*#__PURE__*/React.createElement(GetForm, {
    handler: selectedAmenity ? editAmenity : addAmenity
  }));
});
AmenityModal.propTypes = {
  selectedAmenity: PropTypes.string,
  title: PropTypes.string,
  info: PropTypes.string,
  multiple: PropTypes.bool
};